<template><div><h1 id="op-liste-manueller-buchungen" tabindex="-1"><a class="header-anchor" href="#op-liste-manueller-buchungen"><span>OP-Liste manueller Buchungen</span></a></h1>
<p>OP-Liste manueller Buchungen — Eine Liste aller OP, welche aus manuellen Buchungen entstanden sind</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aller OP, welche aus manuellen Buchungen entstanden sind. Sortierung nach Personen-ID, Datum, Zahlungsnummer oder Habenkonto wählbar. Es ist möglich, auch die Infozeilen pro einzelnen OP anzuzeigen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → OP-Kontoauszüge → OP-Liste manueller Buchungen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>von Datum:
: inklusive, leer = unbegrenzt</p>
</li>
<li>
<p>bis :
: inklusive, leer = unbegrenzt</p>
</li>
<li>
<p>OP Typen:
: Buchungstyp, mit Kommas trennen, mit ! ausschliessen, * alles</p>
</li>
<li>
<p>Erfasser:
: Erfasser, mit Kommas trennen, mit ! ausschliessen, * alles</p>
</li>
<li>
<p>Sortierung nach:
: Sortierung nach Personen-ID, Datum, Habenkonto, Zahlungsnummer</p>
</li>
<li>
<p>Info pro OP:
: Infozeilen pro OP: ja/nein</p>
</li>
</ul>
<p>:</p>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
<dt>- Bildschirm</dt>
<dd>
<ul>
<li>Bildschirm</li>
</ul>
</dd>
<dt>- Drucker:</dt>
<dd>A4 quer</dd>
<dt>- Textdatei:</dt>
<dd>Text</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Info-Felder:</td>
<td>Rekapitulation der gewählten Parameter</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- Personen-ID:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>- Buchungstyp:</td>
<td>Buchungstyp</td>
</tr>
<tr>
<td>- Konto:</td>
<td>Konto der Buchungszeile</td>
</tr>
<tr>
<td>- Kostenstelle:</td>
<td>Kostenstelle der Buchungszeile</td>
</tr>
<tr>
<td>- Kostenträger:</td>
<td>Kostenträger der Buchungszeile</td>
</tr>
<tr>
<td>- Datum:</td>
<td>Buchungsdatum</td>
</tr>
<tr>
<td>- Zahlungsnummer:</td>
<td>Zahlungsnummer</td>
</tr>
<tr>
<td>- Ereignis:</td>
<td>Ereignisnummer mit Ereignisposition</td>
</tr>
<tr>
<td>- Erfasser:</td>
<td>Erfasser der Buchung</td>
</tr>
<tr>
<td>- Betrag Soll:</td>
<td>Sollbetrag</td>
</tr>
<tr>
<td>- Betrag Haben:</td>
<td>Habenbetrag</td>
</tr>
<tr>
<td>- Info:</td>
<td>I = Informationstext zum OP vorhanden</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>- Total:</td>
<td>Summe pro Spalte [Betrag Soll] und [Betrag Haben] aus allen verarbeiteten OP</td>
</tr>
</tbody>
</table>
<p>Liste manueller Buchungen</p>
<pre><code>          Datum von: 01.04.1995    Erfasser: Alle
          Datum bis: 01.04.2008    Sortierung nach.: Zahlungsnummer
          OP Typen: Alle           Info pro OP: ja
</code></pre>
<h2 id="adressnr-t-konto-kst-ktr-betrag-s-betrag-hdatum-i-zahlnr-ereig-ep-aid" tabindex="-1"><a class="header-anchor" href="#adressnr-t-konto-kst-ktr-betrag-s-betrag-hdatum-i-zahlnr-ereig-ep-aid"><span>Adressnr T          Konto       Kst      Ktr         Betrag S   Betrag H
Datum      I ZahlNr Ereig EP AId</span></a></h2>
<pre><code>    50 AS Auftrag                                      3.00       0.00
       26.10.1998 I      ?     ? 00 pav
    50 AS Auftrag                                     12.00       0.00
       26.10.1998        ?     ? 00 pav
    50 AS Auftrag                                      6.00       0.00
       26.10.1998        ?     ? 00 pav
 1,004 S  Spende  1900                                 0.00     200.00
       21.10.1998        0  9998 00 pav
 1,004 Z  Zahlung 1900                               200.00       0.00
       21.10.1998        0  9998 00 pav
</code></pre>
<p>.                                                     ---------- ----------
436.00     200.00 TOTAL</p>
<p>Lesebeispiel: Für Personen-ID 50 wurde am 26.10.98 ein Auftragsstorno im Betrag von Fr. 3.-- erfasst. Es existiert dazu ein Informationstext in den Offenen Posten. Die Buchung ist mit keinem Ereignis verknüpft. Erfasser war pav.</p>
</div></template>


